const BOT_USER_AGENT =
  /bot|crawl|spider|slurp|scrap|fetch|preview|headless|lighthouse|monitoring|cfnetwork|facebookexternalhit|whatsapp|python|curl|wget|go-http-client|java\/|okhttp|axios|httpclient|libwww|ahrefs|semrush|ia_archiver/i;

/**
 * Whether the user agent belongs to a crawler, link previewer or other
 * non-browser client. A missing user agent counts as a bot.
 *
 * @param {string | undefined | null} userAgent
 * @returns {boolean}
 */
export function isBot(userAgent) {
  return !userAgent || BOT_USER_AGENT.test(userAgent);
}
